import * as API from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Apis } from '../constants';

interface FetchOptions {
  method: string;
  headers: object;
  body?: any;
  response?: boolean;
}

async function localFetch(path: string, options: FetchOptions, api: string) {
  // TODO: Make sure this works. Also appears in src/state/middleware/requestUpdates.ts
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString() || '';

  const headers = {
    ...(options.headers || {}),
    Authorization: authToken,
  };

  const fetchPath = `${process.env.REACT_APP_LOCAL_API_URL}/${api}${path}`;
  const opt = {
    ...options,
    headers,
  };

  return fetch(fetchPath, opt).then((res) => {
    if (res.status === 204) {
      return Promise.resolve(res);
    }

    const promise = res.ok ? res.json() : Promise.reject(res);

    return promise.then((data) => {
      return {
        ...res,
        data,
      };
    });
  });
}

export default class APIService {
  static async GET(path: string, api = Apis.CORE, settings = {}): Promise<any> {
    const options = {
      headers: {},
      response: true,
      ...settings,
    };

    if (process.env.REACT_APP_LOCAL_API_URL) {
      return localFetch(
        path,
        {
          ...options,
          method: 'GET',
        },
        api,
      );
    }

    const res = await API.get({ apiName: api, path, options }).response;
    const data = await res.body.json();
    return { data };
  }

  static async POST(path: string, api = Apis.CORE, body = {}, headers = {}, settings = {}): Promise<any> {
    const options = {
      body,
      headers,
      ...settings,
    };

    if (process.env.REACT_APP_LOCAL_API_URL) {
      const localOptions = {
        body: body instanceof FormData ? body : JSON.stringify(body),
        headers: {
          ...headers,
          ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        },
        method: 'POST',
      };
      return localFetch(path, localOptions, api);
    }

    const res = await API.post({ apiName: api, path, options }).response;
    const data = await res.body.json();

    return { data };
  }

  static DELETE(path: string, api = Apis.CORE): Promise<any> {
    const options = {
      headers: {},
    };

    if (process.env.REACT_APP_LOCAL_API_URL) {
      return localFetch(
        path,
        {
          ...options,
          method: 'DELETE',
        },
        api,
      );
    }

    return API.del({ apiName: api, path, options }).response;
  }

  static PUT(path: string, api = Apis.CORE, body = {}, headers = {}): Promise<any> {
    const options = {
      body,
      headers,
    };

    if (process.env.REACT_APP_LOCAL_API_URL) {
      const localOptions = {
        body: JSON.stringify(body),
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
        method: 'PUT',
      };

      return localFetch(path, localOptions, api);
    }

    return API.put({ apiName: api, path, options }).response;
  }
}
